// Define the order of service type filters.

const filterServiceTypeOptions = [
  {
    children: [],
    slug: 'allTypes',
    suppress: [2],
  },
  {
    children: [],
    slug: 'hospitals',
    suppress: [],
  },
  {
    children: [],
    slug: 'physiciansAndClinics',
    suppress: [],
  },
  {
    children: [],
    slug: 'dental',
    suppress: [],
  },
  {
    children: [],
    slug: 'otherProfessionalServices',
    suppress: [],
  },
  {
    children: [],
    slug: 'prescriptionDrug',
    suppress: [],
  },
  {
    children: [],
    slug: 'homeHealth',
    suppress: [],
  },
  {
    children: [],
    slug: 'nursingCare',
    suppress: [],
  },
  {
    children: [],
    slug: 'otherHealthAndResidential',
    suppress: [],
  },
  {
    children: [],
    slug: 'healthConsumption',
    suppress: [],
  },
  {
    children: [],
    slug: 'personalHealthCare',
    suppress: [],
  },
  {
    children: [],
    slug: 'durableMedicalEquipment',
    suppress: [],
  },
  {
    children: [],
    slug: 'nonDurableMedicalProducts',
    suppress: [],
  },
  {
    children: [],
    slug: 'stateAndLocalAdministration',
    suppress: [],
  },
  {
    children: [],
    slug: 'totalAdministration',
    suppress: [],
  },
  {
    children: [],
    slug: 'federalAdministration',
    suppress: [],
  },
  {
    children: [],
    slug: 'netCostOfHealthInsurance',
    suppress: [],
  },
];

export default filterServiceTypeOptions;
